import { xApiService } from '../services/xApiService';

export interface PostResult {
  method: 'api' | 'intent';
  tweetId?: string;
}

/**
 * X APIの credentials が設定されてたらAPI経由で直接投稿、
 * なければ従来の intent URL にフォールバック
 */
export async function postToX(text: string): Promise<PostResult> {
  if (xApiService.hasCredentials()) {
    const { tweetId } = await xApiService.postTweet(text);
    return { method: 'api', tweetId };
  }

  // Fallback: intent URL
  const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
  return { method: 'intent' };
}
